import React, {useEffect} from "react";
import {connect} from "react-redux";
import {setPricingNotification} from "../pricingActions";
import PricingContext, {usePricingContext} from "../PricingContext";
import {getCurrentUpdateCount} from "../pricingSavingLogic";

const PricingNotification = (props) => {

  const {pricingNotification, setPricingNotification} = props;
  const {visible, type, text} = pricingNotification;

  const {routeParams} = usePricingContext(PricingContext);
  const {paramsGroupName} = routeParams;

  useEffect(() => {
    if (!visible) {
      return
    }
    setPricingNotification(false);
  }, [paramsGroupName]);

  return (
    <div className={"pr-notification border-box text-center flex flex--center color-white transition2"
      + (visible ? " pr-notification--visible" : "")
      + (type === "error" ? " bg-red" : (type === "success") ? " bg-green" : " bg-blue")}>
      <p className="margin-0" dangerouslySetInnerHTML={{__html: text || "Success"}}/>
      <button className="ui-close pr-notification__close ui-close--gray3 ui-close--gray3--active ui-close--small"
              onClick={() => setPricingNotification(false)}/>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {pricingNotification} = store.pricingState;
  return {
    pricingNotification,
    pricingUpdatesCount: getCurrentUpdateCount(store),
  };
};

const mapDispatchToProps = {
  setPricingNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(PricingNotification);
